module.exports = __webpack_public_path__ + "static/media/mint_img.66bf8761.png";